"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_KLASS_ITEM = void 0;
const moment_1 = __importDefault(require("moment"));
exports.DEFAULT_KLASS_ITEM = {
    id: '',
    creation_time: (0, moment_1.default)().toISOString(),
    status: '',
    tenant_id: '',
    identifier: '',
    title: '',
    subject: '',
    startline: (0, moment_1.default)().toISOString(),
    deadline: (0, moment_1.default)().toISOString(),
    capacity: 0,
    hidden_menus: [],
    members: [],
    managers: [],
    host: '',
    members_name: [],
    managers_name: [],
    host_name: '',
};
